export default "__VITE_ASSET__WbntN1aL__"